import { CodeRoot } from "./code.slots";

/**
 * # Code
 *
 * renders code blocks
 *
 * @see {@link https://nimbus-documentation.vercel.app/components/typography/code}
 *
 * @experimental This component is experimental and may change or be removed in future versions.
 */
export const Code: typeof CodeRoot = CodeRoot;
